import React, { useState, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';
import NotificationsActions from '~redux/notifications';

import { UserContext } from '~contexts/user';

import { Suspense, ErrorBoundary } from '~components/suspense';
import FormSkeleton from '~components/forms/skeleton';
import Hero from '~components/hero';

import OperationsForm from './form';
import { useDefaultOperations } from './default-operations';

import '~containers/intake/style.scss';
import './style.scss';

const Operations = () => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, isLoading, updateWorker } = useContext(UserContext);
  const { operations } = user;
  const defaultOperations = useDefaultOperations();
  const operationsToBeEdited =
    !operations || !operations.address || !operations.address.place_id ? defaultOperations : operations;
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (operations.personalNote) {
    operationsToBeEdited.personalNote = operations.personalNote;
  }

  useLayout({ type: 'account', displayCities: false });
  useSeo(intl.formatMessage({ id: 'containers.operations.title', defaultMessage: 'Preferences - #website' }));

  const handleSubmit = useCallback(async (newOperations) => {
    try {
      setIsSubmitting(true);
      const newUser = { ...user, operations: newOperations };
      await updateWorker(newUser);
      dispatch(
        NotificationsActions.addNotification(
          intl.formatMessage({ id: 'containers.operations.notification', defaultMessage: 'Offer saved successfully' })
        )
      );
      setIsSubmitting(false);
      history.push(`/customers?locationId=${newOperations.address?.locationId}` || '/account');
    } catch (err) {
      console.log('Error while updating user', err);
    }
  });

  return (
    <div className="c-account__main l-container">
      <Hero.Wrapper>
        <Hero.Title>
          {intl.formatMessage({ id: 'containers.operations.headline', defaultMessage: 'My offer' })}
        </Hero.Title>
      </Hero.Wrapper>
      <Suspense fallback={<FormSkeleton align="center" />} isLoading={isLoading}>
        <ErrorBoundary fallback={<h2 className="l-error">Could not fetch operations</h2>}>
          <OperationsForm operations={operationsToBeEdited} onSubmit={handleSubmit} isSubmitting={isSubmitting} />
        </ErrorBoundary>
      </Suspense>
    </div>
  );
};

export default Operations;
